import React from 'react'
import Navigation from '../reusableComponent/Navigation'
import Footer from '../reusableComponent/Footer'
import Contacts from '../reusableComponent/Contacts'

const NavContact = () => {
    return (
        <div>
            <Navigation />
            <Contacts />
            <Footer />
        </div>
    )
}

export default NavContact